import React from 'react';
import { Search, RotateCcw } from 'lucide-react';
import { RESULTS_SECTION_STRINGS } from '../../constants/appConstants';
import styles from './SearchResultsEmptyState.module.scss';

const SearchResultsEmptyState = ({ matchType, onReset }) => (
  <div className={styles.emptyState}>
    <Search size={48} strokeWidth={1} />
    <h3>{RESULTS_SECTION_STRINGS.EMPTY.TITLE}</h3>
    <p>
      {matchType === 'exact'
        ? RESULTS_SECTION_STRINGS.EMPTY.EXACT_NO_MATCH
        : RESULTS_SECTION_STRINGS.EMPTY.FILTER_NO_MATCH}
    </p>
    <button className={styles.resetBtn} onClick={onReset}>
      <RotateCcw size={14} />
      {RESULTS_SECTION_STRINGS.EMPTY.RESET_BUTTON}
    </button>
  </div>
);

export default React.memo(SearchResultsEmptyState);
